'use client'

import Button from 'shared/ui/Button'
import toast from 'shared/ui/utils/toast'
import { getApiErrors } from 'shared/utils/errors'

import { redirectToGoogleLogin } from '../api/externalLogin'

import styles from './GoogleLoginButton.module.scss'

interface Response {
  data: {
    data: string
  }
}

const GoogleLoginButton = () => {
  const handleSubmit = () => {
    redirectToGoogleLogin()
      .then(resp => {
        const response = resp as Response

        let url = response.data.data

        const urlObj = new URL(url)

        urlObj.searchParams.set('prompt', 'select_account')
        url = urlObj.toString()

        const el = document.createElement('a')

        el.href = url
        el.click()
        el.remove()
      })
      .catch(err => {
        toast.error(getApiErrors(err))
      })
  }

  return (
    <Button
      variant='neutralOutline'
      size='large'
      type='button'
      fullWidth
      startIcon={<div className={styles.icon} />}
      onClick={handleSubmit}
    >
      Kontynuuj przez Google
    </Button>
  )
}

export default GoogleLoginButton
